module.exports = __webpack_public_path__ + "img/box2.0c1be1f4.png";